import { Injectable } from "@angular/core";
import { EnvironmentState } from "./environment.state";
import { createStore, withProps } from "@ngneat/elf";

export function createInitialState(): { environment: EnvironmentState } {
	switch (location.hostname) {
		case "mobaro-rideops-app.azurewebsites.net":
		case "rideops.mobaro.com": {
			return { environment: EnvironmentState.Production };
		}
		case "mobaro-rideops-app-staging.azurewebsites.net":
		case "rideops.staging.mobaro.com":
		case "white-sea-03141fc03.7.azurestaticapps.net":
		case "rideops.beta.mobaro.com": {
			return { environment: EnvironmentState.Staging };
		}
		default: {
			return { environment: EnvironmentState.Development };
		}
	}
}

const environmentStore = createStore(
	{ name: "environment" },
	withProps<{ environment: EnvironmentState }>(createInitialState()),
);

@Injectable({ providedIn: "root" })
export class EnvironmentStore {
	public store = environmentStore;

	reset = () => {
		environmentStore.reset();
	};
}
